import {ChangeDetectorRef, Component, forwardRef, OnInit, ViewChild} from "@angular/core";
import {Supplier} from "../../../shared/view-model/crm/supplier.type";
import {SupplierService} from "../../services/supplier/supplier.service";
import {FormBuilder, FormControl} from "@angular/forms";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {appInjector} from "../../../index";
import {GenericModalComponent} from "../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {SupplierFormComponent} from "../supplier-form/supplier-form.component";

@Component({
  selector: 'vb-supplier-selection',
  templateUrl: './supplier-selection.component.html',
  styleUrls: ['./supplier-selection.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => SupplierSelectionComponent)}]
})
export class SupplierSelectionComponent extends AbstractVisbosControl<Supplier, FormControl> implements OnInit {

  supplierList: Supplier[] = [];

  constructor(fb: FormBuilder, cd: ChangeDetectorRef,
              private supplierService?: SupplierService) {
    super(fb, cd, null);
  }

  @ViewChild(GenericModalComponent)
  modal: GenericModalComponent;

  @ViewChild('form')
  form: SupplierFormComponent;

  ngOnInit() {
    super.ngOnInit();

    this.dataSubscriptions.push(this.supplierService.getSupplierList(this.activeAdminUnitCuid$)
      .subscribe((res: any) => {
        this.supplierList = res;
      }));

  }

  buildControlContent(): FormControl {
    return SupplierSelectionComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormControl {
    fb = fb ? fb : appInjector().get(FormBuilder);
    return fb.control(null);
  }

  public setDefaultValues(item?: Supplier): { [controlKey: string]: any } | any {
    return this.setValue(item, 'cuid');
  }

  createSupplier() {
    this.form.createOrUpdateSupplier();
  }

}



// WEBPACK FOOTER //
// ./src/app/crm/supplier/supplier-selection/supplier-selection.component.ts